import { GameEventBus } from '@core/Bus/GameEventBus';
import { CrashEvents, CrashEventBus } from './CrashEvents';

export class CrashGameEventBus implements CrashEventBus {
  private static instance: CrashGameEventBus;
  private baseBus = GameEventBus.getInstance();

  static getInstance(): CrashGameEventBus {
    if (!CrashGameEventBus.instance) {
      CrashGameEventBus.instance = new CrashGameEventBus();
    }
    return CrashGameEventBus.instance;
  }

  publish<K extends keyof CrashEvents>(event: K, data: CrashEvents[K]): void {
    console.log(`[CrashEventBus] Publishing: ${event}`, data);
    this.baseBus.publish(event as any, data);
  }

  subscribe<K extends keyof CrashEvents>(
    event: K,
    handler: (data: CrashEvents[K]) => void
  ): () => void {
    console.log(`[CrashEventBus] Subscribing to: ${event}`);
    return this.baseBus.subscribe(event as any, handler);
  }

  subscribeMultiple<K extends keyof CrashEvents>(
    events: K[],
    handler: (event: K, data: CrashEvents[K]) => void
  ): () => void {
    const unsubscribers = events.map(event =>
      this.subscribe(event, data => handler(event, data))
    );

    return () => unsubscribers.forEach(unsub => unsub());
  }

  onPlaneEvent(
    handler: (
      event: 'crash:plane:takeoff' | 'crash:plane:landing',
      data: any
    ) => void
  ): () => void {
    return this.subscribeMultiple(
      ['crash:plane:takeoff', 'crash:plane:landing'],
      handler
    );
  }

  onMultiplierEvent(
    handler: (
      event: 'crash:multiplier:milestone' | 'multiplier:updated',
      data: any
    ) => void
  ): () => void {
    return this.subscribeMultiple(
      ['crash:multiplier:milestone', 'multiplier:updated'],
      handler
    );
  }

  onPhaseTransition(
    handler: (data: CrashEvents['crash:phase:transition']) => void
  ): () => void {
    return this.subscribe('crash:phase:transition', handler);
  }
}

export const crashEvents = CrashGameEventBus.getInstance();
